// Which kind of feed an id names, decided from the id alone.
//
// It has to be the id alone, because that is all there is. GET /feeds returns bare strings and says
// so in as many words — services/feeds.js: "single-input and multi-input together (a feed is a feed;
// the list doesn't distinguish)". The two sound alternatives both cost a round trip the picker
// cannot make: asking /score_specs for every spec and matching their published feed names, or
// reading the feed itself, whose `inputs` markers are the thing slim drops.
//
// So this is a HEURISTIC, and everything built on it is advisory. It filters SUGGESTIONS. It never
// gates what can be submitted — the field takes any typed id, which is the whole premise of the
// picker (FeedPicker.js) and the reason a wrong guess here costs a click rather than an outcome.
//
// THE TEST IS THE PREFIX, NOT specIdForFeed. Publishing applies `score_spec_` unconditionally,
// including on the free-form `scores[].feed_name` branch, so the prefix is provenance: it says a
// score spec published this. specIdForFeed parses the REMAINDER and deliberately fails closed,
// which is right for "which spec published this" and wrong here — it calls `score_spec_acme_conviction`
// not-a-spec-feed (see its test) though that is an ordinary single-spec feed with a free-form name.
// feedArity.test.js pins the disagreement so that "simplifying" one into the other trips an alarm.
//
// KNOWN IMPERFECT, in one direction that matters: `false` means "not provably one spec's output",
// not "combined". A feed that is neither prefixed nor combined lands in the multi bucket, and
// nothing in this repo states that a multi-input feed id may NOT begin `score_spec_` — the API doc
// calls the list a union and asserts no disjointness. That uncertainty is why `all` is a real
// segment and the default: a misclassified feed is one click from visible, never unreachable.
const FEED_PREFIX = 'score_spec_';

export const isScoreSpecFeed = (feedId) => String(feedId || '').startsWith(FEED_PREFIX);

export const FEED_KINDS = { all: 'all', single: 'single', multi: 'multi' };

// Beside the rule, so the vocabulary has one home rather than a label in the form and a predicate
// here disagreeing about what they divide.
export const FEED_KIND_SEGMENTS = [
  { key: FEED_KINDS.all, label: 'All' },
  { key: FEED_KINDS.single, label: 'Single-spec' },
  { key: FEED_KINDS.multi, label: 'Multi-spec' },
];

// Fails OPEN on anything that isn't one of the two narrowing kinds, so a stale or garbled value
// shows every feed rather than hiding every feed. A filter that empties the list for a reason the
// analyst cannot see is worse than no filter.
export const matchesFeedKind = (feedId, kind) => {
  if (kind !== FEED_KINDS.single && kind !== FEED_KINDS.multi) return true;
  return isScoreSpecFeed(feedId) === (kind === FEED_KINDS.single);
};

export const filterFeedsByKind = (feeds, kind) => {
  const list = feeds || [];
  if (kind !== FEED_KINDS.single && kind !== FEED_KINDS.multi) return list;
  return list.filter((id) => matchesFeedKind(id, kind));
};
